import React from 'react';
import { StyleSheet } from 'react-native';
import { Container } from '@mui/system';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FooterContainer } from '../../components/ScreenContainer/FooterScreenContainer/FooterContainer';
import { Campaign } from '@mui/icons-material';

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100dvh',
    },
});

const Advertise = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            <FooterContainer>
                <Box>
                    <Card
                        sx={{
                            backgroundColor: theme[themeStyle].secondaryBg,
                            borderRadius: 2,
                            textAlign: 'center',
                            py: 6,
                        }}>
                        <CardContent>
                            <Campaign sx={{ fontSize: 64, color: theme[themeStyle].primary_white, mb: 2 }} />
                            <Typography
                                sx={{
                                    fontFamily: FONT_ENUM.MAIN_BOLD,
                                    fontSize: '1.5rem',
                                    color: theme[themeStyle].primary_white,
                                    mb: 1,
                                }}>
                                Advertise Coming Soon
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: FONT_ENUM.MAIN_REGULAR,
                                    fontSize: '1rem',
                                    color: theme[themeStyle].light_gray_text,
                                    maxWidth: 500,
                                    mx: 'auto',
                                }}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse
                                lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum
                                ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi. Proin
                                porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit
                                amet erat. Duis semper. Duis arcu massa, scelerisque vitae, consequat in, pretium a,
                                enim.
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            </FooterContainer>
        </Container>
    );
};

export { Advertise };
